export default "__VITE_ASSET__xker3JXq__"